// This file is generated automatically by scripts/generate-flag.js. Don't modify it.
import React from 'react';
import Qatar from '../_raw/flag/icon_flag_qatar.png';

export default () => <img src={Qatar} alt="Qatar" />;
